import React from "react";
import styles from './ConfessionCard.module.css';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';


function ConfessionCardSkelton() {

  return (
    <Box
      width='100%'
      className={styles.box}
    >
      <div className={styles.cardHeader}>
        <Skeleton style={{marginRight: 30}} width="20%">
            <h3 className={styles.name}>Name</h3>
        </Skeleton>
        <Skeleton width="10%">
            <p className={styles.date}>2022/04</p>
        </Skeleton>
      </div>
      <Skeleton height="40px" width="90%">
        <h4>Yo this is my confession</h4>
      </Skeleton>
    </Box>
  );
}

export default ConfessionCardSkelton;
